// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/SchoolBundle/India/flexible-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flexible_header {
  background: linear-gradient(to bottom, #002ae199, #002ae199),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  height: 300px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

header.flexible_header p {
  font-size: 18px;
}

section.flexible_plan_page_body.container {
  background: #f4f6fc;
  margin-top: -60px;
  padding: 50px 100px;
}

.fp-Pheading {
  color: var(--LPink) !important;
}

h2.flexible_plan_page_title {
  position: relative;
  font-size: 18px;
  background: var(--LPink);
  color: #fff;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  padding: 5px 15px;
  border-radius: 20px;
  margin: -100px auto 40px auto;
  z-index: 11;
  /* margin-top: -14px; */
}
section.flexible_plan_page_body h2 {
  font-size: 22px;
  margin: 50px 0px 30px 0px;
  color: var(--dBlue);
  font-weight: 600;
}

section.flexible_plan_page_body ul li {
  font-size: 16px;
}

.flexible_plan_page_body {
  text-align: justify;
}

@media (max-width: 576px) {
  section.flexible_plan_page_body.container {
    padding: 50px 30px;
  }
  .flexible_header {
    padding: 20px;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/india-bundle/Flexible/FlexiblePlan.css"],"names":[],"mappings":"AAAA;EACE;2CACqE;EACrE,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF","sourcesContent":[".flexible_header {\n  background: linear-gradient(to bottom, #002ae199, #002ae199),\n    url(\"../../../../public/images/SchoolBundle/India/flexible-bg.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 300px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n\nheader.flexible_header p {\n  font-size: 18px;\n}\n\nsection.flexible_plan_page_body.container {\n  background: #f4f6fc;\n  margin-top: -60px;\n  padding: 50px 100px;\n}\n\n.fp-Pheading {\n  color: var(--LPink) !important;\n}\n\nh2.flexible_plan_page_title {\n  position: relative;\n  font-size: 18px;\n  background: var(--LPink);\n  color: #fff;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  padding: 5px 15px;\n  border-radius: 20px;\n  margin: -100px auto 40px auto;\n  z-index: 11;\n  /* margin-top: -14px; */\n}\nsection.flexible_plan_page_body h2 {\n  font-size: 22px;\n  margin: 50px 0px 30px 0px;\n  color: var(--dBlue);\n  font-weight: 600;\n}\n\nsection.flexible_plan_page_body ul li {\n  font-size: 16px;\n}\n\n.flexible_plan_page_body {\n  text-align: justify;\n}\n\n@media (max-width: 576px) {\n  section.flexible_plan_page_body.container {\n    padding: 50px 30px;\n  }\n  .flexible_header {\n    padding: 20px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
